/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_RehabInputs */

const en_for_whom_tag_rehab = /** @type {(inputs: For_Whom_Tag_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehab`)
};

const pl_for_whom_tag_rehab = /** @type {(inputs: For_Whom_Tag_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehabilitacja`)
};

/**
* | output |
* | --- |
* | "Rehab" |
*
* @param {For_Whom_Tag_RehabInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_rehab = /** @type {((inputs?: For_Whom_Tag_RehabInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_RehabInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_rehab(inputs)
	return en_for_whom_tag_rehab(inputs)
});